import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import classNames from "classnames";

import Icon from "shared/react_components/MaterialIcon";
import IconWithTooltip from "shared/react_components/IconWithTooltip";

import { button, icon as iconClassName, smaller } from "./styles.module.scss";

const IconButton = ({
  icon,
  tooltipText,
  className,
  component: Component,
  small,
  tooltipPlacement,
  ...props
}) => (
  <Component
    className={classNames(button, className, { [smaller]: small })}
    {...props}
  >
    {tooltipText ? (
      <IconWithTooltip icon={icon} className={iconClassName} placement={tooltipPlacement}>
        {tooltipText}
      </IconWithTooltip>
    ) : (
      <Icon name={icon} className={iconClassName} />
    )}
  </Component>
);

IconButton.propTypes = {
  /**
   * See Material Icon documentation for available icon names
   */
  icon: PropTypes.string.isRequired,
  /**
   * Any additional classnames will be appended to the default classes
   */
  className: PropTypes.string,
  /**
   * Provide an alternative component to wrap the Icon (e.g Router Link or NavLink)
   */
  component: PropTypes.elementType,
  /**
   * Display smaller size for the button
   */
  small: PropTypes.bool,

  /**
   * Tooltip displayed on the icon
   */
  tooltipText: PropTypes.string,

  /**
   * Placement of the tooltip displayed on the icon
   */
  tooltipPlacement: PropTypes.string
};

IconButton.defaultProps = {
  component: Button,
  small: false,
  tooltipPlacement: "right"
};

export default IconButton;
